import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'
import CollapsibleSectionStyles from '../styles/components/collapsible-section'

/**
 *Represents a collection of ExpansionPanels that could be expanded or collapsed
 *
 * @class CollapsibleSections
 * @extends {Component}
 */
class CollapsibleSections extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      expandedKey: undefined
    }
  }

  handleChange = panelKey => (event, expanded) => {
    // var item = this.props.items[panelKey]
    this.setState({
      expandedKey: expanded ? panelKey : false
    })
  }

  render () {
    // render all the items in the collection
    if (!this.props.items) {
      return null
    }

    const { classes } = this.props
    const { expandedKey } = this.state

    return this.props.items.map((t, i) => {
      return (
        <div key={i} className={classes.root}>
          <ExpansionPanel className={classes.panel} expanded={expandedKey === i} onChange={this.handleChange(i)}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.heading}>{t.heading}</Typography>
              {t.secondaryHeading
                ? <Typography className={classes.secondaryHeading}>{t.secondaryHeading}</Typography>
                : null}
            </ExpansionPanelSummary>
            <ExpansionPanelDetails className={classes.details}>
              {t.content}
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>
      )
    })
  }
}

CollapsibleSections.defaultProps = {
  singleExpand: false
}

CollapsibleSections.propTypes = {
  items: PropTypes.arrayOf(PropTypes.exact(
    {
      heading: PropTypes.string.isRequired,
      secondaryHeading: PropTypes.string,
      content: PropTypes.element.isRequired
    }
  )),
  singleExpand: PropTypes.bool
}

const styles = theme => ({
  ...CollapsibleSectionStyles(theme)
})

export default withStyles(styles)(CollapsibleSections)



// WEBPACK FOOTER //
// ./src/controls/CollapsibleSections.js